import React from "react";
import "./ActiveApplications.css";
import { Table, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function ActiveApplications() {
  const applications = [
    { name: "Garde Manger", status: "Under Review", date: "12 Oct 2025" },
    { name: "Sous Chef", status: "Accepted", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", status: "Refused", date: "01 Nov 2025" },
    { name: "Student Advisor", status: "Payment Due", date: "06 Nov 2025" },

    { name: "Garde Manger", status: "Under Review", date: "12 Oct 2025" },
    { name: "Sous Chef", status: "Accepted", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", status: "Refused", date: "01 Nov 2025" },
    { name: "Student Advisor", status: "Payment Due", date: "06 Nov 2025" },

    { name: "Garde Manger", status: "Under Review", date: "12 Oct 2025" },
    { name: "Sous Chef", status: "Accepted", date: "24 Oct 2025" },
    { name: "Saucier (Sauce Chef)", status: "Refused", date: "01 Nov 2025" },
    { name: "Student Advisor", status: "Payment Due", date: "06 Nov 2025" },
  ];

  const statusClass = {
    "Under Review": "under-review",
    Accepted: "accepted",
    Refused: "refused",
    "Payment Due": "payment-due",
  };

  return (
    <div className="Dashboard__ActiveApplications card_box">
      <h5 className="mb-3 card_heading_holder">Active Applications</h5>

      <div className="custom_table table_scroll">
        <Table borderless responsive>
          <thead>
            <tr>
              <th>Program Name</th>
              <th>Status</th>
              <th>Last Update</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {applications.map((app, index) => (
              <tr key={index}>
                <td>{app.name}</td>

                <td>
                  <span className={`status-badge ${statusClass[app.status]}`}>
                    {app.status}
                  </span>
                </td>

                <td>{app.date}</td>

                <td>
                  <div className="action_btn_holder">
                    <Link to={"/portal/student/applications"}>
                      <Button className="eye_btn action_btn_icon">
                        <FontAwesomeIcon icon={faEye} />
                      </Button>
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default ActiveApplications;
